import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheckIcon } from 'lucide-react';
export function NotDiagnosis() {
  return <section className="bg-white py-16 px-6" data-id="element-220">
      <div className="max-w-[680px] mx-auto" data-id="element-221">
        <FadeIn data-id="element-222">
          <div className="bg-[#FDF8F3] p-8 rounded-2xl border border-[#3BBFAD]/20 relative overflow-hidden" data-id="element-223">
            <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-224">
              <ShieldCheckIcon className="w-24 h-24 text-[#1B2A4A]" data-id="element-225" />
            </div>

            <h2 className="font-serif text-3xl text-[#1B2A4A] mb-6 relative z-10" data-id="element-226">
              Esto NO es un diagnóstico
            </h2>

            <div className="space-y-4 text-[#1B2A4A]/80 text-lg leading-relaxed relative z-10" data-id="element-227">
              <p data-id="element-228">Empecemos por lo obvio (porque internet no lo hace):</p>
              <p className="font-medium" data-id="element-229">
                Una guía no puede diagnosticar. Y esta guía no lo intenta.
              </p>
              <p data-id="element-230">
                Lo que sí puede hacer —y lo que tú necesitas ahora— es darte:
                <span className="block text-2xl font-serif text-[#3BBFAD] mt-2 italic" data-id="element-231">
                  claridad accionable.
                </span>
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}